// Enregistrement du service worker (porté de flowAI, ServiceWorkerRegister.tsx) : en production
// seulement, portée racine, silencieux si non pris en charge (l'appli reste une page web).
export function enregistrerServiceWorker(): void {
  if (!import.meta.env.PROD || typeof navigator === 'undefined' || !('serviceWorker' in navigator))
    return
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js', { scope: '/' }).catch((e: unknown) => {
      console.warn('Service worker non enregistré :', e)
    })
  })
}

/** Invite d'installation de Chrome et Edge (Android, ordinateur). */
export type InvitationInstallation = Event & {
  prompt: () => Promise<void>
  userChoice: Promise<{ outcome: 'accepted' | 'dismissed' }>
}

let invitation: InvitationInstallation | null = null
const abonnesInvitation = new Set<() => void>()

/**
 * Garde l'invite d'installation, qui arrive tôt et une seule fois, pour la proposer au clic sur
 * « Installer l'appli » (écran d'installation).
 */
export function capturerInvitationInstallation(): void {
  if (typeof window === 'undefined') return
  window.addEventListener('beforeinstallprompt', (e) => {
    e.preventDefault()
    invitation = e as InvitationInstallation
    for (const a of [...abonnesInvitation]) a()
  })
  window.addEventListener('appinstalled', () => {
    invitation = null
    for (const a of [...abonnesInvitation]) a()
  })
}

export function lireInvitation(): InvitationInstallation | null {
  return invitation
}

export function consommerInvitation(): void {
  invitation = null
  for (const a of [...abonnesInvitation]) a()
}

export function surInvitation(a: () => void): () => void {
  abonnesInvitation.add(a)
  return () => void abonnesInvitation.delete(a)
}
